export default __webpack_public_path__ + "static/media/nike_airforce_product_page.5174f549.png";